var _excluded = ["svgRef", "title"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var _ref2 =
/*#__PURE__*/
/*#__PURE__*/
React.createElement("g", {
  fill: "none",
  fillRule: "evenodd",
  opacity: 0.9
}, /*#__PURE__*/React.createElement("path", {
  d: "m30.24 15.803c0 8.043-4.874 8.98-5.79 17.75 0 .392-.157.768-.436 1.046-.28.277-.658.432-1.052.432h-15.197a1.49 1.49 0 0 1 -1.052-.432 1.472 1.472 0 0 1 -.435-1.046c-.913-8.77-5.788-9.707-5.788-17.75 0-8.17 6.66-14.791 14.877-14.791 8.216 0 14.877 6.622 14.877 14.79h-.003z",
  stroke: "#003a70",
  strokeWidth: 0.796
}), /*#__PURE__*/React.createElement("path", {
  d: "m22.802 37.56h-14.876a1.49 1.49 0 0 0 -1.289.74 1.472 1.472 0 0 0 0 1.479c.266.457.757.74 1.289.74h14.876c.822 0 1.488-.663 1.488-1.48s-.666-1.48-1.488-1.48m0 4.735h-14.876c-.822 0-1.488.663-1.488 1.48s.666 1.48 1.488 1.48h14.876c.822 0 1.488-.663 1.488-1.48s-.666-1.48-1.488-1.48m-10.414 7.694h5.952c.79 0 1.546-.311 2.104-.866a2.947 2.947 0 0 0 .87-2.093h-11.9c-.001.785.312 1.538.87 2.093a2.982 2.982 0 0 0 2.104.866",
  fill: "#ff4438",
  fillRule: "nonzero"
}));
var SvgLightBulb = function SvgLightBulb(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 50,
    viewBox: "0 0 31 50",
    width: 31,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgLightBulb, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/LightBulb.6440781a.svg";
export { ForwardRef as ReactComponent };